// extracted by mini-css-extract-plugin
export var buttons = "bp_cD";
export var current = "bp_fm";
export var image = "bp_g";
export var marker = "bp_fl";
export var markers = "bp_fk";
export var p = "bp_fd";
export var promotions = "bp_fn";
export var section = "bp_d";
export var textContainer = "bp_cq";